import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { dateRangeForDatagridTable } from "./recoilState";

export const useDateRangeFilter = () => {
  const filterValues = useRecoilValue(dateRangeForDatagridTable);
  const dateRangeFilter = useMemo(() => {
    if (!filterValues) {
      return {};
    }
    return {
      and: [{ notificationSend: { gte: filterValues[0] } }, { notificationSend: { lte: filterValues[1] } }],
    };
  }, [filterValues]);
  return { dateRangeFilter };
};
